import { render } from "./MW2023StaticPage.vue?vue&type=template&id=6950e279"
import script from "./MW2023StaticPage.vue?vue&type=script&lang=js"
export * from "./MW2023StaticPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__